module.exports = __webpack_public_path__ + "img/ExitusMujer-INF01.401c3c12.png";